import { Box, Text, Flex, Image } from '@chakra-ui/react';
import { SliceComponentProps } from '@prismicio/react';
import React from 'react';
import Link from '../../Link';

const BreadcrumbsSlice = (props: BreadcrumbsSliceType) => {
  const { slice } = props;
  return (
    <Flex w='100%' py='16px' pos='relative' align='center' flexWrap='wrap'>
      <Box
        pos='absolute'
        w='100vw'
        top='0'
        bottom='0'
        ml='-50vw'
        left='50%'
        zIndex='-2'
        bg='aliceblue.200'
      />
      {slice.items.map((item, index) => {
        return (
          <>
            <Link to={item.breadcrumb_item_link} key={`item-${index}`} noHover>
              <Text
                color={item.breadcrumb_item_link ? 'grey.700' : 'blue.800'}
                _hover={{ color: 'blue.800' }}
              >
                {item.breadcrumb_item}
              </Text>
            </Link>
            {item.breadcrumb_item_link && (
              <Image
                src={slice.primary.separator_icon.url}
                alt={slice.primary.separator_icon.alt}
                mx='12px'
              />
            )}
          </>
        );
      })}
    </Flex>
  );
};

export type BreadcrumbsSliceType = SliceComponentProps<{
  id: string;
  items: {
    breadcrumb_item: string;
    breadcrumb_item_link?: string;
  }[];
  primary: {
    separator_icon?: {
      url: string;
      alt: string;
    };
  };
  slice_type: string;
}>;

export default BreadcrumbsSlice;
